import { render, staticRenderFns } from "./Pedidos.vue?vue&type=template&id=f4c51c0c&"
import script from "./Pedidos.vue?vue&type=script&lang=js&"
export * from "./Pedidos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports